import React, {Component} from "react";
import axios from "axios";
import Slider from "react-slick";
import {Image} from "react-bootstrap";
import * as jalaliMoment from "jalali-moment";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";

export class NewsDetail extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            page: {},
            images: []
        };
    }

    componentDidMount() {
        let pageSlug = this.props.match.params.slug;

        (async () => {
            const result = await axios.post(
                process.env.REACT_APP_API_URL + process.env.REACT_APP_GET_PAGE_CONTENT_PATH + pageSlug + '.json',
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
                }
            );

            if (result.data.result && result.data.result.data) {
                const page = result.data.result.data.page;
                const images = result.data.result.data.images;
                this.setState({ page, images, isLoading: false });
            }
        })();
    }

    renderDate = () => {
        let news_date = jalaliMoment(this.state.page.modified, 'YYYY/M/D')
            .locale('fa')
            .format('jD jMMMM YYYY');

        return (
            <div className="d-flex align-items-center">
                <span>
                    <i className="fas fa-calendar-alt"> </i>
                </span>
                <a href="" className="ml-20">
                    <span className="opacity-7">منتشر شده در</span>
                    <h6 className="fz-16">{news_date}</h6>
                </a>
            </div>
        );
    }

    renderGallery = () => {
        if (this.state.images.length === 0) {
            return null;
        }

        const settings = {
            lazyLoad: 'ondemand',
            //slidesToShow: (this.state.images.length >= 3) ? 3 : this.state.images.length,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <section className="work-carsouel full-height valign section-padding">
                <div className="container-fluid rest">
                    <div className="row">
                        <div className="col-12">
                            <div className="slider-carousel">
                                <Slider {...settings}>
                                    {this.state.images.map((image, key) => {
                                        const image_src = image ?? process.env.REACT_APP_BASE_URL + "/images/default/news.jpg";
                                        return (
                                            <article key={key} className="carousel-direction">
                                                <div className="property_item heading_space">
                                                    <div className="image">
                                                        <Image
                                                            src={image_src}
                                                            alt="latest property"
                                                            className="img-responsive"
                                                            style={{height: 400}}
                                                        />
                                                    </div>
                                                </div>
                                            </article>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    render() {
        let newsUrl = "/news-detail/" + this.props.match.params.slug;
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="page-header blog-header">
                        <div className="container mt-80">
                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <a href={"/pages/news"}><span>اخبار</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>{this.props.match.params.slug}</span>
                                        </div>
                                        {!this.state.isLoading
                                            ? <h1 className="fz-45 mt-30">{this.state.page.title}</h1>
                                            : <div className='pt-30 pb-10 padding-rl-50'><DottedLoading/></div>}
                                    </div>

                                    <div className="info d-flex mt-40 align-items-center">
                                        <div className="left-info">
                                            <div className="d-flex">
                                                <div className="author-info">
                                                    {!this.state.isLoading && this.renderDate()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </header>
                    <section className="blog pt-40">
                        <div className="container">
                            <div className="main-post pb-70">
                                <div className="item pb-60">
                                    <div>
                                        <div className="row justify-content-center">
                                            <div className="col-lg-10 auto-text">
                                                {!this.state.isLoading
                                                    ? <div className='text' dangerouslySetInnerHTML={{ __html: this.state.page.body }} />
                                                    : <div className='pt-30 pb-30 padding-rl-50'>
                                                        <DottedLoading/>
                                                      </div>}
                                            </div>
                                        </div>
                                    </div>

                                    {!this.state.isLoading
                                        ? this.renderGallery()
                                        : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}

                                </div>
                                <div className="info-area flex mt-20 pb-20">
                                    <div>
                                        <div className="tags flex">
                                            <div className="valign">
                                                <span>تگ ها :</span>
                                            </div>
                                            {!this.state.isLoading
                                                ? <div>
                                                    <a href="">اخبار</a>
                                                    <a href="">اخبار شرکت</a>
                                                    <a href="">پایدارایرانیان</a>
                                                  </div>
                                                : <div className='pt-10 pb-10 padding-rl-50'>
                                                    <DottedLoading/>
                                                  </div>}

                                        </div>
                                    </div>
                                    <div className="ml-auto">
                                        <div className="share-icon flex">
                                            <div className="valign">
                                                <span>اشتراک :</span>
                                            </div>
                                            <div>
                                                <a href={'https://telegram.me/share/url?url=' + process.env.REACT_APP_BASE_URL + newsUrl}>
                                                    <i className="fab fa-telegram-plane"> </i>
                                                </a>
                                                <a href={'https://twitter.com/intent/tweet?text=' + process.env.REACT_APP_BASE_URL + newsUrl}>
                                                    <i className="fab fa-twitter"> </i>
                                                </a>
                                                <a href={'whatsapp://send?text=' + process.env.REACT_APP_BASE_URL + newsUrl}>
                                                    <i className="fab fa-whatsapp"> </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default NewsDetail;
